import { Mesh, MeshBasicMaterial, Object3D, SphereGeometry, Vector3, } from 'three';
import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
export default class DrawModule extends ViewerModule {
    constructor(level) {
        super();
        this.level = level;
        // public recipe: any;
        this.currentStep = -1;
    }
    init(burnModule) {
        this.currentStep = -1;
        this.spotContainer = new Object3D();
        this.addObject(this.spotContainer);
        this.spotContainer.name = 'spotContainer';
        this.spotContainer.position.set(0, 1, 2.6);
        this.burnModule = burnModule;
        this.uiObject.name = 'DRAW MODULE';
        this.uiObject.position.set(0, -2.9, 1.68);
        this.uiObject.rotation.set(-0.27, 0, -0.07);
        this.uiObject.scale.setScalar(0.74);
        this.uiObject.userData.pcPosition = this.uiObject.position.clone();
        this.uiObject.userData.pcRotation = this.uiObject.rotation.clone();
        this.uiObject.userData.pcScale = this.uiObject.scale.x;
        this.dish = this.dish || deepClone(ResourcesManager.getModel('petri_blue_empty').clone());
        this.dish.traverse(el => {
            if (el.name.toLowerCase().includes('plane'))
                el.visible = false;
        });
        this.dish.position.set(0, 1, 3);
        this.dish.rotation.set(Math.PI / 2, 0, 0);
        this.dish.scale.setScalar(4.7);
        this.addObject(this.dish);
        if (Viewer.controls.zController) {
            this.uiObject.position.set(0, -2, -3.9);
            this.uiObject.rotation.set(0, 0, 0);
            this.uiObject.scale.setScalar(1.5);
        }
        this.dish.children[0].material.opacity = 1;
        this.dish.children[0].material.transparent = false;
        console.log('DRAW MODULE', this);
        this.pointList = [
            [
                new Vector3(0, 1.2, 0),
                new Vector3(.2, 1, 0),
                new Vector3(.4, .8, 0),
                new Vector3(.6, .6, 0),
                new Vector3(.8, .4, 0),
                new Vector3(1, .2, 0),
                new Vector3(1.2, 0, 0)
            ],
            [
                new Vector3(1.2, 0, 0),
                new Vector3(1, -.2, 0),
                new Vector3(.8, -.4, 0),
                new Vector3(.6, -.6, 0),
                new Vector3(.4, -.8, 0),
                new Vector3(.2, -1, 0),
                new Vector3(0, -1.2, 0)
            ],
            [
                new Vector3(0, -1.2, 0),
                new Vector3(-.2, -1, 0),
                new Vector3(-.4, -.8, 0),
                new Vector3(-.6, -.6, 0),
                new Vector3(-.8, -.4, 0),
                new Vector3(-1, -.2, 0),
                new Vector3(-1.2, 0, 0)
            ],
            [
                new Vector3(-1.2, 0, 0),
                new Vector3(-1, 0.2, 0),
                new Vector3(-.8, 0.4, 0),
                new Vector3(-.6, 0.6, 0),
                new Vector3(-.4, 0.8, 0),
                new Vector3(-.2, 1, 0),
                new Vector3(0, 1.2, 0)
            ],
            [
                new Vector3(0, 1, 0),
                new Vector3(.1, 0.8, 0),
                new Vector3(.2, .6, 0),
                new Vector3(.3, 0.4, 0),
                new Vector3(.4, 0.2, 0),
                new Vector3(.2, .2, 0),
                new Vector3(0, .2, 0),
                new Vector3(-.2, .2, 0),
                new Vector3(-.4, .2, 0),
                new Vector3(-.6, .2, 0),
                new Vector3(-.4, -.1, 0),
                new Vector3(-.2, -.2, 0),
                new Vector3(0, -.3, 0),
                new Vector3(.2, -.4, 0),
                new Vector3(.4, -.5, 0),
                new Vector3(.6, -.6, 0),
                new Vector3(.4, -.7, 0),
                new Vector3(.2, -.8, 0),
                new Vector3(0, -.9, 0),
                new Vector3(.1, -1, 0),
                new Vector3(.2, -1.1, 0),
                new Vector3(.3, -1.2, 0),
            ],
        ];
        this.spotsToClean = [];
        this.nextLine();
    }
    nextLine() {
        this.currentStep++;
        this.pointList[this.currentStep].forEach(position => {
            const spot = new Mesh(new SphereGeometry(.1, 32, 32), new MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: 1 }));
            this.actionController.on(ActionControllerEventName.over, spot, () => {
                if (Viewer.controls.zController)
                    return;
                this.disposeObject(spot);
                this.spotsToClean.splice(this.spotsToClean.indexOf(spot), 1);
                if (this.spotsToClean.length === 0) {
                    if (this.currentStep !== 4) {
                        this.nextLine();
                    }
                    else {
                        this.fire('spread_ended');
                        this.dispose();
                    }
                }
            });
            this.actionController.on(ActionControllerEventName.out, spot, () => {
            });
            this.spotsToClean.push(spot);
            this.addObject(spot, null, this.spotContainer);
            spot.position.copy(position);
        });
        if (Viewer.controls.zController && this.currentStep === 0) {
            let event;
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.burnModule.loop.parent, event = () => {
                this.spotsToClean.forEach(spot => {
                    const distanceToSpot = this.burnModule.loop.getWorldPosition(new Vector3()).distanceTo(spot.getWorldPosition(new Vector3()));
                    if (distanceToSpot < 0.23) {
                        this.disposeObject(spot);
                        this.spotsToClean.splice(this.spotsToClean.indexOf(spot), 1);
                        if (this.spotsToClean.length === 0) {
                            if (this.currentStep !== 4) {
                                this.nextLine();
                            }
                            else {
                                this.fire('spread_ended');
                                this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.burnModule.loop.parent, event);
                                this.dispose();
                            }
                        }
                    }
                });
            });
        }
    }
    reset() {
        // this.uiObject.visible = false;
        // if (this.spotContainer.parent) this.spotContainer.parent.remove(this.spotContainer);
        if (this.dish && this.dish.parent)
            this.dish.parent.remove(this.dish);
        if (this.spotContainer)
            for (let i = this.spotContainer.children.length - 1; i >= 0; i--) {
                this.spotContainer.remove(this.spotContainer.children[i]);
            }
    }
}
